import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEmail2"><Path d="M22 4H2V6.78938L12 11.8211L22 6.78937V4Z" fill="currentColor"/><Path d="M22 8.46857L12 13.5003L2 8.46857V20H22V8.46857Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2;
